import { render, staticRenderFns } from "./TheProblem.vue?vue&type=template&id=2a1118b0"
import script from "./TheProblem.vue?vue&type=script&lang=ts"
export * from "./TheProblem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1118b0')) {
      api.createRecord('2a1118b0', component.options)
    } else {
      api.reload('2a1118b0', component.options)
    }
    module.hot.accept("./TheProblem.vue?vue&type=template&id=2a1118b0", function () {
      api.rerender('2a1118b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheProblem.vue"
export default component.exports